<p-confirmDialog key="main" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Menu Bar-->
<div class="lock-to-top" style="background-color: #ffffff">
	<!--School Select-->
	<div class="selector-body">
		<div class="selector-item">
			<div>
				<label>School</label>
			</div>

			<div style="margin-left: 10px">
				<!-- Note: (ngModelChange) must go after [(ngModel)] or you get prev selected item!  -->
				<!-- <select class="form-control" name="SchoolID" style="font-size:smaller;"
					[(ngModel)]="SchoolID"
					(ngModelChange)="onSchoolChange($event)">
					<option *ngFor="let r of lstSchool" [ngValue]="r.SchoolID">[{{r.SchoolNumber}}] - {{r.SchoolName}}</option>
				</select> -->

				<caass-schoolselector [ShowAll]="false" [Disabled]="IsLoading()"> </caass-schoolselector>
			</div>
		</div>
	</div>

	<!--Buttons-->
	<div class="button-body flex">
		<button [disabled]="IsLoading() == true" class="btn btn-primary" style="margin-left: 0px" (click)="onRefresh()">Refresh</button>

		<!--INSERT CUSTOM BUTTONS HERE-->
		<button [disabled]="IsLoading() == true" class="btn btn-primary" style="margin-left: 5px" (click)="onAdd()">Add Point</button>
		<button [disabled]="IsLoading() == true" class="btn btn-primary" style="margin-left: 5px" (click)="onEdit()">Edit Point</button>
		<button [disabled]="IsLoading() == true" class="btn btn-primary" style="margin-left: 5px" (click)="onToggle()">Toggle Point</button>
		<button *ngIf="IsSU() == true" [disabled]="IsLoading() == true" class="btn btn-danger" style="margin-left: 5px" (click)="onDelete()">
			Delete Point (SU Only)
		</button>
	</div>
</div>

<!--Table-->
<div class="table-main-body">
	<p-table
		#mydt
		[value]="lstPointsItem"
		[loading]="loading"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="single"
		[(selection)]="SelectedPointsItem"
		dataKey="PointsItemID"
		(onFilter)="onHandleFilter($event)"
		(onSort)="onHandleSort($event)"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<!--INSERT CUSTOM FILTERS HERE-->

				<!--PointsItemDesc-->
				<th>
					<p-columnFilter type="text" field="PointsItemDesc" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--PointsCategoryDesc-->
				<th>
					<p-columnFilter field="PointsCategoryDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterPointsCategoryDesc
								[ngModel]="value"
								[options]="lstPointsCategoryDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--PointsCategoryTypeDesc-->
				<th>
					<p-columnFilter field="PointsCategoryTypeDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterPointsCategoryTypeDesc
								[ngModel]="value"
								[options]="lstPointsCategoryTypeDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--PointsItemValue-->
				<th>
					<!-- <p-columnFilter type="text" field="PointsItemValue" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
				</th>

				<!--ActiveDesc-->
				<th>
					<p-columnFilter field="ActiveDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterActiveDesc
								[ngModel]="value"
								[options]="lstActiveDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--UseInClassRoomDesc-->
				<th>
					<p-columnFilter field="UseInClassRoomDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterUseInClassRoomDesc
								[ngModel]="value"
								[options]="lstUseInClassRoomDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<!--INSERT CUSTOM COLUMNS HERE-->
				<th pSortableColumn="PointsItemDesc">Point<p-sortIcon field="PointsItemDesc"></p-sortIcon></th>
				<th pSortableColumn="PointsCategoryDesc">Category<p-sortIcon field="PointsCategoryDesc"></p-sortIcon></th>
				<th pSortableColumn="PointsCategoryTypeDesc">Category Type<p-sortIcon field="PointsCategoryTypeDesc"></p-sortIcon></th>
				<th pSortableColumn="PointsItemValue">Value<p-sortIcon field="PointsItemValue"></p-sortIcon></th>
				<th pSortableColumn="ActiveDesc">Active<p-sortIcon field="ActiveDesc"></p-sortIcon></th>
				<th pSortableColumn="UseInClassRoomDesc">Use In Classroom<p-sortIcon field="UseInClassRoomDesc"></p-sortIcon></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-PointsItem>
			<tr [pSelectableRow]="PointsItem" (dblclick)="onRowDblClick(PointsItem)">
				<td *ngFor="let col of cols" style="font-weight: bold">
					{{ PointsItem[col.field] }}
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>

<div *ngIf="isProcessing" class="TopMargin">
	<div name="Saveing" *ngIf="isProcessing" class="alert alert-info">Processing.Please wait...</div>
</div>
